import { gql, TypedDocumentNode } from '@apollo/client'

import { ATTRIBUTE_FRAGMENT } from './attribute'

import type { AbTestsVariantsSchemaDTO } from 'features/ab-tests/api/types/abTestsVariantsSchemaDTO'

export const UNFILLED_RECOVERY_FRAGMENT: TypedDocumentNode<
  AbTestsVariantsSchemaDTO['unfilledRecovery']
> = gql`
  ${ATTRIBUTE_FRAGMENT}

  fragment abTestsVariantsUnfilledRecoveryFragment on AbTestsVariantsUnfilledRecovery {
    unfilledRecoveryEnabled {
      ...abTestsVariantsAttributesFragment
    }
    label
  }
`
